module.exports = __webpack_public_path__ + "img/my_page.f80e9395.svg";